import React, { useState } from "react";
import LinkSlider from "../Components/LinkSlider";
import { SubscribeSection } from "../Components/SubscribeSection";
import { motion } from "framer-motion";
import Faq from "../Components/Faq";
// import OurSolutionBanner from "../Components/OurSolutionBanner";
import EsgSection from "../Components/EsgSection";
import { useLanguage } from "../Router/LanguageContext";

export default function AboutUs() {
  const [activeIndex, setActiveIndex] = useState(0);
  const { dictionary } = useLanguage();

  const data = [
    {
      title: dictionary?.value1Title,
      desc: dictionary?.value1Desc,
    },
    {
      title: dictionary?.value2Title,
      desc: dictionary?.value2Desc,
    },
    {
      title: dictionary?.value3Title,
      desc: dictionary?.value3Desc,
    },
    {
      title: dictionary?.value4Title,
      desc: dictionary?.value4Desc,
    },
  ];

  const ourMission = {
    title: dictionary?.missionTitle,
    description: dictionary?.missionDesc,
    arrayData: [
      dictionary?.missionPoint1,
      dictionary?.missionPoint2,
      dictionary?.missionPoint3,
      dictionary?.missionPoint4,
    ],
    img1: "/assets/img/energySector.png",
    img2: "/assets/img/energySectorEffect.png",
  };

  const ourVision = {
    title: dictionary?.visionTitle,
    description: dictionary?.visionDesc,
    arrayData: [
      dictionary?.visionPoint1,
      dictionary?.visionPoint2,
      dictionary?.visionPoint3,
      dictionary?.visionPoint4,
    ],
    img1: "/assets/img/vissionImage.png",
    img2: "/assets/img/energySectorEffect.png",
  };

  const executionCapability = {
    title: dictionary?.executionTitle,
    description: dictionary?.executionDesc1,
    descriptionSec: dictionary?.executionDesc2,
    img1: "/assets/img/Execution.png",
    img2: "/assets/img/energySectorEffect.png",
  };

  return (
    <>
      {/* <OurSolutionBanner
        title="About US"
        description="Rooted in Angola. Positioned for Global"
        bgImage="/assets/img/aboutMain.jpg"
      /> */}

      <div className="heroSectionBgVideoWrapper">
        {/* <video className="bgVideo" autoPlay muted loop playsInline>
          <source src="/assets/video/LandingVideo.mp4" type="video/mp4" />
        </video> */}
        <img src="/assets/img/aboutMain.jpg" alt="" className="bgVideo" />
        <div className="heroSectionContentOuter">
          <div className="container-fluid maxContainerSection">
            <div className="row heroSectionContent">
              <div className="col-md-12 heroLeftSection aboutTextCenter">
                <h2 className="m-0 f-s-48">{dictionary?.aboutTitle}</h2>
                <p className="m-0 f-s-20">{dictionary?.aboutSubtitle}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="section section-banner">
        <div className="container-fluid maxContainerSection">
          <div className="row justify-content-center block-about-us">
            <div className="col-lg-3 col-md-3 text-center animate-content">
              <h2 className="m-0 f-w-600 f-s-60 about-us-title block-titleBold">
                About us
              </h2>
              <p className="m-0 f-s-20 about-us-desc">
                Rooted in Angola. Positioned for Global
              </p>
            </div>
          </div>
        </div>
      </div> */}

      <LinkSlider />

      <div className="section section-who-we-are">
        <div className="container-fluid maxContainerSection mobile-contain-padding">
          <div className="row justify-content-center">
            <div className="col-lg-10 col-md-8 text-center col-block-top">
              <h2 className="m-0 f-w-600 f-s-48 block-title block-titleBold">
                {dictionary?.whoWeAreTitle}
              </h2>
              <p className="m-0 f-s-20 block-desc">
                {dictionary?.whoWeAreDesc}
              </p>
            </div>
          </div>

          <div className="row ourSolutionSection row-solution-about-us">
            <div className="col-md-6">
              <div className="energySectorImage">
                <motion.img
                  src={ourMission?.img1}
                  className="img-fluid"
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.8 }}
                  viewport={{ once: true }}
                />
                <motion.img
                  src={ourMission?.img2}
                  className="img-fluid energySectorEffect"
                  initial={{ opacity: 0, scale: 0.85 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  whileHover={{
                    scale: 1.03,
                    transition: { duration: 0.25, ease: "easeIn" },
                  }}
                  transition={{ duration: 1, ease: "easeInOut" }}
                  viewport={{ once: true }}
                />
              </div>
            </div>
            <div className="col-md-6 energysection">
              <motion.h2
                className="mission-title m-0 f-s-48"
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                viewport={{ once: true }}
              >
                {ourMission.title}
              </motion.h2>
              <motion.p
                className="mission-text m-0 f-s-18"
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                viewport={{ once: true }}
              >
                {ourMission?.description}
              </motion.p>
              <ul className="mission-list">
                {ourMission?.arrayData?.map((item, i) => (
                  <motion.li
                    key={i}
                    initial={{ opacity: 0, x: 30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.4, delay: 0.4 + i * 0.15 }}
                    viewport={{ once: true }}
                  >
                    <div className="energysectionpoints f-s-18">
                      <img src="/assets/img/tickIcon.svg" alt="" /> {item}
                    </div>
                  </motion.li>
                ))}
              </ul>
            </div>
          </div>

          <div className="row ourSolutionSection row-solution-about-us flex-column-reverse flex-md-row row-vision">
            <div className="col-md-6 energysection">
              <motion.h2
                className="mission-title m-0 f-s-48"
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                viewport={{ once: true }}
              >
                {ourVision.title}
              </motion.h2>
              <motion.p
                className="mission-text m-0 f-s-18"
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                viewport={{ once: true }}
              >
                {ourVision?.description}
              </motion.p>
              <ul className="mission-list">
                {ourVision?.arrayData?.map((item, i) => (
                  <motion.li
                    key={i}
                    initial={{ opacity: 0, x: -30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.4, delay: 0.4 + i * 0.15 }}
                    viewport={{ once: true }}
                  >
                    <div className="energysectionpoints f-s-18">
                      <img src="/assets/img/tickIcon.svg" alt="" /> {item}
                    </div>
                  </motion.li>
                ))}
              </ul>
            </div>

            <div className="col-md-6">
              <div className="energySectorImage vissionEffectOuter">
                <motion.img
                  src={ourVision?.img1}
                  className="img-fluid"
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.8 }}
                  viewport={{ once: true }}
                />
                <motion.img
                  src={ourVision?.img2}
                  className="img-fluid energySectorEffect vissionEffect"
                  initial={{ opacity: 0, scale: 0.85 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  whileHover={{
                    scale: 1.03,
                    transition: { duration: 0.25, ease: "easeIn" },
                  }}
                  transition={{ duration: 1, ease: "easeInOut" }}
                  viewport={{ once: true }}
                />
              </div>
            </div>
          </div>

          <div className="row ourSolutionSection row-solution-about-us">
            <div className="col-md-6">
              <div className="energySectorImage">
                <motion.img
                  src={executionCapability?.img1}
                  className="img-fluid"
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.8 }}
                  viewport={{ once: true }}
                />
                <motion.img
                  src={executionCapability?.img2}
                  className="img-fluid energySectorEffect"
                  initial={{ opacity: 0, scale: 0.85 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  whileHover={{
                    scale: 1.03,
                    transition: { duration: 0.25, ease: "easeIn" },
                  }}
                  transition={{ duration: 1, ease: "easeInOut" }}
                  viewport={{ once: true }}
                />
              </div>
            </div>
            <div className="col-md-6 energysection">
              <motion.h2
                className="mission-title m-0 f-s-48"
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                viewport={{ once: true }}
              >
                {executionCapability.title}
              </motion.h2>
              <motion.p
                className="mission-text m-0 f-s-18"
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                viewport={{ once: true }}
              >
                {executionCapability?.description}
              </motion.p>
              <motion.p
                className="mission-text m-0 f-s-18"
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                viewport={{ once: true }}
              >
                {executionCapability?.descriptionSec}
              </motion.p>
              <ul className="mission-list">
                {executionCapability?.arrayData?.map((item, i) => (
                  <motion.li
                    key={i}
                    initial={{ opacity: 0, x: 30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.4, delay: 0.4 + i * 0.15 }}
                    viewport={{ once: true }}
                  >
                    <div className="energysectionpoints f-s-18">
                      <img src="/assets/img/tickIcon.svg" alt="" /> {item}
                    </div>
                  </motion.li>
                ))}
              </ul>
            </div>
          </div>

          <div className="row justify-content-center row-our-values">
            <div className="col-lg-10 col-md-10 text-center col-block-topWhy">
              <h2 className="m-0 f-w-600 f-s-48 block-title block-titleBold">
                {dictionary?.whyTitle}
              </h2>
              <p className="m-0 f-s-20 block-desc">{dictionary?.whyDesc}</p>
            </div>
          </div>

          <div className="row whyQuimenergy">
            <div className="col-md-12 quimenergyPositions">
              <p className="m-0 f-s-20 block-desc">{dictionary?.whyIntro}</p>
            </div>
            <div className="col-md-3">
              <div className="whoWeAreCard">
                <img src="/assets/img/locationSec.svg" alt="" />
                <h6 className="m-0 f-s-18 f-l-30">{dictionary?.whyPoint1}</h6>
                <div className="borderBottom"></div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="whoWeAreCard">
                <img src="/assets/img/thundersec.svg" alt="" />
                <h6 className="m-0 f-s-18 f-l-30">{dictionary?.whyPoint2}</h6>
                <div className="borderBottom"></div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="whoWeAreCard">
                <img src="/assets/img/toolssec.svg" alt="" />
                <h6 className="m-0 f-s-18 f-l-30">{dictionary?.whyPoint3}</h6>
                <div className="borderBottom"></div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="whoWeAreCard">
                <img src="/assets/img/shealdsec.svg" alt="" />
                <h6 className="m-0 f-s-18 f-l-30">{dictionary?.whyPoint4}</h6>
                <div className="borderBottom"></div>
              </div>
            </div>

            <div className="col-md-12">
              <div className="supportSection f-s-18 f-l-28">
                {dictionary?.whySupport}
              </div>
            </div>
          </div>

          <div className="row justify-content-center row-our-values">
            <div className="col-lg-7 col-md-7 text-center col-block-top">
              <h2 className="m-0 f-w-600 f-s-48 block-title block-titleBold">
                {dictionary?.valuesTitle}
              </h2>
              <p className="m-0 f-s-20 block-desc">{dictionary?.valuesDesc}</p>
            </div>
          </div>

          <div className="row flex-column-reverse flex-md-row">
            {/* Left Side */}
            <div className="col-md-6">
              <div className="ourValuesLeft">
                {data.map((item, index) => (
                  <div
                    key={index}
                    className={`ourValuesItem ${
                      activeIndex === index ? "ourValuesItemActive" : ""
                    }`}
                    onMouseEnter={() => setActiveIndex(index)}
                  >
                    <h4 className="m-0 f-w-600 f-s-20">{item.title}</h4>
                    <p className="m-0 f-s-16">{item.desc}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* Right Side */}
            <div className="col-md-6 col-values-img">
              <motion.img
                className="value-img-main"
                src="/assets/img/our-values-main.png"
                alt=""
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true }}
              />
              <motion.img
                className="value-img-left box-img-common-style"
                src="/assets/img/img-value-left.png"
                alt=""
                initial={{ opacity: 0, scale: 0.85 }}
                whileInView={{ opacity: 1, scale: 1 }}
                whileHover={{
                  scale: 1.03,
                  transition: { duration: 0.25, ease: "easeIn" },
                }}
                transition={{ duration: 1, ease: "easeInOut" }}
                viewport={{ once: true }}
              />
              <motion.img
                className="value-img-right box-img-common-style"
                src="/assets/img/discussion-two-person.png"
                alt=""
                initial={{ opacity: 0, scale: 0.85 }}
                whileInView={{ opacity: 1, scale: 1 }}
                whileHover={{
                  scale: 1.03,
                  transition: { duration: 0.25, ease: "easeIn" },
                }}
                transition={{ duration: 1, ease: "easeInOut" }}
                viewport={{ once: true }}
              />
            </div>
          </div>
        </div>
      </div>

      <Faq />

      {/* <div className="section section-fig">
        <div className="container-fluid maxContainerSection container-fig">
          <div className="row">
            <div className="col-md-4 col-lg-4 text-center">
              <h1 className="m-0 f-w-600 f-s-60">20+</h1>
              <p className="m-0 f-w-500 f-s-20">Years on market</p>
            </div>
            <div className="col-md-4 col-lg-4 text-center">
              <h1 className="m-0 f-w-600 f-s-60">20M+</h1>
              <p className="m-0 f-w-500 f-s-20">Big projects</p>
            </div>
            <div className="col-md-4 col-lg-4 text-center">
              <h1 className="m-0 f-w-600 f-s-60">60+</h1>
              <p className="m-0 f-w-500 f-s-20">Trusted partners</p>
            </div>
          </div>
        </div>
      </div> */}

      <EsgSection />
      <SubscribeSection />
    </>
  );
}
